<template>
  <div class="book">
    <div class="page left">
      <h1>準備中.....</h1>

      <div v-for="(block, index) in japaneseBlocks" :key="'ja-'+index">
        <p class="kobun block"><strong>{{ block.kobun }}</strong></p>
        <p class="genndaibun">{{ block.translation }}</p>
      </div>
    </div>

    <div class="page right">
      <div class="video">
        <div class="video-container">
          <iframe :src="youtubeEmbedUrl" frameborder="0" allowfullscreen></iframe>
        </div>
      </div>
      <h2>五轮书准备中</h2>

      <div v-for="(block, index) in chineseBlocks" :key="'zh-'+index">
        <p class="kobun block"><strong>{{ block.kobun }}</strong></p>
        <p class="genndaibun">{{ block.translation }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
const youtubeEmbedUrl = "https://www.youtube.com/embed/视频ID";

const japaneseBlocks = [
  { kobun: "此兵法の書、五巻に仕立つる事", translation: "この兵法の書を、五巻に仕立てる事" },
  { kobun: "五つの道をわかち...", translation: "自ら道具を研ぎ..." },
  // ... 其他日文区块内容继续补充
];

const chineseBlocks = [
  { kobun: "此兵法书，分为五卷。", translation: "本兵法书共分五卷" },
  { kobun: "亲手研磨其器...", translation: "亲手打磨工具..." },
  // ... 其他中文区块内容继续补充
];
</script>

<style lang="scss">
@import "./fiveRingsCss.scss";
</style>
